import { ReactNode } from 'react';

export type RowContents = {
  data: ReactNode;
  sortValue?: string | null;
  path?: string;
  previewComponent?: React.ElementType<any>;
  previewProps?: Record<string, string>;
};

export type Row = Record<string, RowContents>;
export type Rows = Row[];

export const getPaginatorOptions = (rows: Rows, { pageSize }) => {
  const numPages = Math.ceil(rows.length / pageSize) || 1;

  return Array.from(new Array(numPages), (_, index) => {
    return {
      value: index,
      label: index + 1,
    };
  });
};

export const getPageRows = (page: number, rows: Rows, { pageSize, hasPagination }) => {
  if (!hasPagination) {
    return rows;
  }

  const beginIndex = page * pageSize;
  const endIndex = beginIndex + pageSize;

  return rows.slice(beginIndex, endIndex);
};
